/**
 * 任务渠道多级选项：按媒体分类 / 媒体类型 / 具体媒体 三级级联
 * 数据来源：媒体清单（channels.json）
 * cascader value 需全局唯一（叶子节点使用 pubCode）；label 用于 Hologres 平台匹配（媒体名称）
 */
export const CHANNEL_OPTIONS = [
  {
    "value": "cat0",
    "label": "TOP媒体",
    "children": [
      {
        "value": "cat0-t0",
        "label": "今日头条",
        "children": [
          {
            "value": "wm_toutiaocn",
            "label": "今日头条"
          }
        ]
      },
      {
        "value": "cat0-t1",
        "label": "哔哩哔哩",
        "children": [
          {
            "value": "wm_bilibilicn_app",
            "label": "哔哩哔哩App"
          }
        ]
      },
      {
        "value": "cat0-t2",
        "label": "小红书",
        "children": [
          {
            "value": "wm_xiaohongshucn_app",
            "label": "小红书"
          }
        ]
      },
      {
        "value": "cat0-t3",
        "label": "微信",
        "children": [
          {
            "value": "im_weixin",
            "label": "微信公众号"
          }
        ]
      },
      {
        "value": "cat0-t4",
        "label": "微博",
        "children": [
          {
            "value": "bg_m_sinacn",
            "label": "新浪微博"
          }
        ]
      },
      {
        "value": "cat0-t5",
        "label": "快手",
        "children": [
          {
            "value": "wm_kuaishoucn_app",
            "label": "快手"
          }
        ]
      },
      {
        "value": "cat0-t6",
        "label": "抖音",
        "children": [
          {
            "value": "wm_douyincn_app",
            "label": "抖音App"
          }
        ]
      },
      {
        "value": "cat0-t7",
        "label": "知乎",
        "children": [
          {
            "value": "forum_zhihucn",
            "label": "知乎"
          },
          {
            "value": "wm_zhihucn",
            "label": "知乎专栏"
          },
          {
            "value": "wm_zhrbcn_app",
            "label": "知乎日报"
          }
        ]
      }
    ]
  },
  {
    "value": "cat1",
    "label": "TOP自媒体平台",
    "children": [
      {
        "value": "cat1-t0",
        "label": "APP",
        "children": [
          {
            "value": "wm_36kecn_app",
            "label": "36氪"
          },
          {
            "value": "wm_uccn_app",
            "label": "UC头条"
          },
          {
            "value": "wm_zakercn_app",
            "label": "ZAKER（新闻阅读）"
          },
          {
            "value": "wm_ydzxcn_app",
            "label": "一点资讯"
          },
          {
            "value": "wm_minieastdaycn_app",
            "label": "东方头条"
          },
          {
            "value": "wm_zhongqingkandiancn_app",
            "label": "中青看点"
          },
          {
            "value": "wm_ifengnewscn_app",
            "label": "凤凰新闻"
          },
          {
            "value": "wm_shoujisouhucn_app",
            "label": "手机搜狐"
          },
          {
            "value": "wm_sohunewscn_app",
            "label": "搜狐新闻"
          },
          {
            "value": "wm_sinanewscn_app",
            "label": "新浪新闻"
          },
          {
            "value": "wm_ksinacn_app",
            "label": "新浪看点"
          },
          {
            "value": "wm_xlcjcn_app",
            "label": "新浪财经"
          },
          {
            "value": "wm_ducn_app",
            "label": "百度"
          },
          {
            "value": "wm_baidunewscn_app",
            "label": "百度新闻"
          },
          {
            "value": "wm_163newscn_app",
            "label": "网易新闻"
          },
          {
            "value": "wm_qqnewscn_app",
            "label": "腾讯新闻"
          },
          {
            "value": "wm_qutoutiaocn_app",
            "label": "趣头条"
          }
        ]
      },
      {
        "value": "cat1-t1",
        "label": "网站",
        "children": [
          {
            "value": "wm_36krcn",
            "label": "36氪"
          },
          {
            "value": "wm_myzakercn",
            "label": "ZAKER"
          },
          {
            "value": "wm_yidianzixuncn",
            "label": "一点资讯"
          },
          {
            "value": "wm_minieastdaycn",
            "label": "东方头条"
          },
          {
            "value": "wm_eastdaycn",
            "label": "东方网"
          },
          {
            "value": "wm_ifenghk",
            "label": "凤凰网"
          },
          {
            "value": "wm_thecovercn",
            "label": "封面"
          },
          {
            "value": "wm_shqihoocn",
            "label": "快资讯"
          },
          {
            "value": "wm_sinaccn",
            "label": "手机新浪网"
          },
          {
            "value": "wm_3g163cn",
            "label": "手机网易网"
          },
          {
            "value": "wm_sohucn",
            "label": "搜狐"
          },
          {
            "value": "wm_sinacn",
            "label": "新浪网"
          },
          {
            "value": "wm_baiducncn",
            "label": "百度"
          },
          {
            "value": "wm_neteasecn",
            "label": "网易"
          },
          {
            "value": "wm_qqcn",
            "label": "腾讯网"
          }
        ]
      }
    ]
  },
  {
    "value": "cat2",
    "label": "党央媒",
    "children": [
      {
        "value": "cat2-t0",
        "label": "APP",
        "children": [
          {
            "value": "wm_chnewsccn_app",
            "label": "Chinanews"
          },
          {
            "value": "wm_egongsicn_app",
            "label": "e公司"
          },
          {
            "value": "wm_xinhuanewscn_app",
            "label": "xinhua News"
          },
          {
            "value": "wm_sannonghaocn_app",
            "label": "三农号"
          },
          {
            "value": "wm_shzqbcn_app",
            "label": "上海证券报"
          },
          {
            "value": "wm_zhongguokuaijibaocn_app",
            "label": "中国会计报"
          },
          {
            "value": "wm_zgjjbcn_app",
            "label": "中国基金报"
          },
          {
            "value": "wm_zgjsbcn_app",
            "label": "中国建设报"
          },
          {
            "value": "wm_zgjybcn_app",
            "label": "中国教育报"
          },
          {
            "value": "wm_chinanewscn_app",
            "label": "中国新闻网"
          },
          {
            "value": "wm_zglvyouxinwencn_app",
            "label": "中国旅游新闻"
          },
          {
            "value": "wm_chinadailycn_app",
            "label": "中国日报"
          },
          {
            "value": "wm_zgmhbcn_app",
            "label": "中国民航报"
          },
          {
            "value": "wm_zhongguofayuanbaocn_app",
            "label": "中国法院网"
          },
          {
            "value": "wm_zghjcn_app",
            "label": "中国环境"
          },
          {
            "value": "wm_zgjjwcn_app",
            "label": "中国经济网"
          },
          {
            "value": "wm_zhongguowangcn_app",
            "label": "中国网"
          },
          {
            "value": "wm_zhongguocaijingcn_app",
            "label": "中国网财经"
          },
          {
            "value": "wm_zgxzwcn_app",
            "label": "中国西藏网"
          },
          {
            "value": "wm_zgzqbcn_app",
            "label": "中国证券报"
          },
          {
            "value": "wm_zgcawcn_app",
            "label": "中国长安网"
          },
          {
            "value": "wm_zhongguoqingnianbaocn_app",
            "label": "中国青年报"
          },
          {
            "value": "wm_zhongxinjingweicn_app",
            "label": "中新经纬"
          },
          {
            "value": "wm_renminjkcn_app",
            "label": "人民健康"
          },
          {
            "value": "wm_peoplecn_app",
            "label": "人民日报"
          },
          {
            "value": "wm_rmrbjkcn_app",
            "label": "人民日报健康"
          },
          {
            "value": "wm_renminribaowccn_app",
            "label": "人民日报文创"
          },
          {
            "value": "wm_people_app",
            "label": "人民网"
          },
          {
            "value": "wm_renminwangcn_app",
            "label": "人民网+"
          },
          {
            "value": "wm_renminspcn_app",
            "label": "人民视频"
          },
          {
            "value": "wm_renminluntancn_app",
            "label": "人民论坛"
          },
          {
            "value": "wm_qiaobaocn_app",
            "label": "侨宝"
          },
          {
            "value": "wm_jksbcn_app",
            "label": "健康时报"
          },
          {
            "value": "wm_guangmingribaocn_app",
            "label": "光明日报"
          },
          {
            "value": "wm_gqtzycn_app",
            "label": "共青团中央"
          },
          {
            "value": "wm_qzscn_app",
            "label": "券中社"
          },
          {
            "value": "wm_banyuetancn_app",
            "label": "半月谈"
          },
          {
            "value": "wm_cankaoxiaoxi_app",
            "label": "参考消息"
          },
          {
            "value": "wm_guojiayingjiguangbocn_app",
            "label": "国家应急广播"
          },
          {
            "value": "wm_cnr_app",
            "label": "央广网"
          },
          {
            "value": "wm_yangshiyingyincn_app",
            "label": "央视影音"
          },
          {
            "value": "wm_cntvnewscn_app",
            "label": "央视新闻"
          },
          {
            "value": "wm_yangshicaijingcn_app",
            "label": "央视财经"
          },
          {
            "value": "wm_yangshipincn_app",
            "label": "央视频"
          },
          {
            "value": "wm_papercnwomencn_app",
            "label": "女性之声"
          },
          {
            "value": "wm_xxqgcn_app",
            "label": "学习强国"
          },
          {
            "value": "wm_zgwbjcn_app",
            "label": "工人日报"
          },
          {
            "value": "wm_wenlvzhongguocn_app",
            "label": "文旅中国"
          },
          {
            "value": "wm_xhscn_app",
            "label": "新华社"
          },
          {
            "value": "wm_xinhuawangcn_app",
            "label": "新华网"
          },
          {
            "value": "wm_xinhuacaijingcn_app",
            "label": "新华财经"
          },
          {
            "value": "wm_jiancharibaocn_app",
            "label": "检察日报"
          },
          {
            "value": "wm_fazhiribaocn_app",
            "label": "法治号"
          },
          {
            "value": "wm_hkxwrmhwcn_app",
            "label": "海客新闻"
          },
          {
            "value": "wm_huanqiu_app",
            "label": "环球Time"
          },
          {
            "value": "wm_liaowangcn_app",
            "label": "瞭望"
          },
          {
            "value": "wm_jjckbcn_app",
            "label": "经济参考报"
          },
          {
            "value": "wm_economic_app",
            "label": "经济日报"
          },
          {
            "value": "wm_jiefangjunbaocn_app",
            "label": "解放军报"
          },
          {
            "value": "wm_zqrbcn_app",
            "label": "证券日报"
          },
          {
            "value": "wm_wapstcncn_app",
            "label": "证券时报"
          },
          {
            "value": "wm_cls_app",
            "label": "财联社"
          },
          {
            "value": "wm_jinrongshibaocn_app",
            "label": "金融时报"
          }
        ]
      },
      {
        "value": "cat2-t1",
        "label": "报纸",
        "children": [
          {
            "value": "sh_shsecur",
            "label": "上海证券报"
          },
          {
            "value": "sd_dfycbszb",
            "label": "东方烟草报"
          },
          {
            "value": "hzsb",
            "label": "中华合作时报"
          },
          {
            "value": "bj_cbtszb",
            "label": "中华工商时报"
          },
          {
            "value": "bj_ccnsc",
            "label": "中国交通报"
          },
          {
            "value": "zgkjb",
            "label": "中国会计报"
          },
          {
            "value": "bj_zgtyszb",
            "label": "中国体育报"
          },
          {
            "value": "bj_zgxxbszb",
            "label": "中国信息报数字报"
          },
          {
            "value": "bj_ldbsc",
            "label": "中国劳动保障报"
          },
          {
            "value": "bj_yybszb",
            "label": "中国医药报"
          },
          {
            "value": "bj_sb",
            "label": "中国商报"
          },
          {
            "value": "zhgmszb",
            "label": "中国国门时报"
          },
          {
            "value": "zggfb",
            "label": "中国国防报"
          },
          {
            "value": "chinafundszb",
            "label": "中国基金报"
          },
          {
            "value": "bj_fnbdzb",
            "label": "中国妇女报(数字报)"
          },
          {
            "value": "bj_zgscjgbszb",
            "label": "中国市场监管报"
          },
          {
            "value": "bj_zgyjglbszb",
            "label": "中国应急管理报数字报"
          },
          {
            "value": "bj_jsbsc",
            "label": "中国建设报"
          },
          {
            "value": "bj_cpsc",
            "label": "中国房地产报"
          },
          {
            "value": "bj_zgggbszb",
            "label": "中国改革报"
          },
          {
            "value": "bj_zgjsbszb",
            "label": "中国教师报"
          },
          {
            "value": "zgjb",
            "label": "中国教育报"
          },
          {
            "value": "bj_whbdzb2",
            "label": "中国文化报"
          },
          {
            "value": "bj_chinadailymr",
            "label": "中国日报"
          },
          {
            "value": "bj_ysjssc",
            "label": "中国有色金属报"
          },
          {
            "value": "zgmzb",
            "label": "中国民族报"
          },
          {
            "value": "bj_zgqxbszb",
            "label": "中国气象报"
          },
          {
            "value": "bj_slbsc",
            "label": "中国水利报"
          },
          {
            "value": "bj_zgqchbaszb",
            "label": "中国汽车报"
          },
          {
            "value": "bj_hybszb",
            "label": "中国海洋报(数字报)"
          },
          {
            "value": "bj_zghjszb",
            "label": "中国环境报"
          },
          {
            "value": "bj_powermr",
            "label": "中国电力报"
          },
          {
            "value": "bj_dzbdzb",
            "label": "中国电子报"
          },
          {
            "value": "zgdybz",
            "label": "中国电影报"
          },
          {
            "value": "bj_zscqszb",
            "label": "中国知识产权报"
          },
          {
            "value": "bj_shbszb",
            "label": "中国石化报"
          },
          {
            "value": "bj_shy",
            "label": "中国石油报"
          },
          {
            "value": "bj_zgshbszb",
            "label": "中国社会报"
          },
          {
            "value": "kxsb",
            "label": "中国科学报"
          },
          {
            "value": "bj_swbmr",
            "label": "中国税务报"
          },
          {
            "value": "bj_jjjcb",
            "label": "中国纪检监察报"
          },
          {
            "value": "bj_ceconszb",
            "label": "中国经济导报(数字报)"
          },
          {
            "value": "bj_cet",
            "label": "中国经济时报"
          },
          {
            "value": "bj_chinabusoc",
            "label": "中国经营报"
          },
          {
            "value": "bj_99grnszb",
            "label": "中国绿色时报"
          },
          {
            "value": "bj_peodny",
            "label": "中国能源报"
          },
          {
            "value": "bj_gtzy",
            "label": "中国自然资源报"
          },
          {
            "value": "bj_cnsecur",
            "label": "中国证券报"
          },
          {
            "value": "bj_zlbszb",
            "label": "中国质量报(数字报)"
          },
          {
            "value": "bj_mybszb",
            "label": "中国贸易报"
          },
          {
            "value": "zgyzszb",
            "label": "中国邮政报"
          },
          {
            "value": "bj_zgqnzjbszb",
            "label": "中国青年作家报"
          },
          {
            "value": "zgqndzb",
            "label": "中国青年报(数字报)"
          },
          {
            "value": "rkdb",
            "label": "人口健康报"
          },
          {
            "value": "rmgaszb",
            "label": "人民公安报"
          },
          {
            "value": "chinapolicetraffic",
            "label": "人民公安报交通安全周刊"
          },
          {
            "value": "bj_cppccszb",
            "label": "人民政协报"
          },
          {
            "value": "bj_peodszb",
            "label": "人民日报(数字报)"
          },
          {
            "value": "bj_peodhw",
            "label": "人民日报海外版"
          },
          {
            "value": "rmfy",
            "label": "人民法院报"
          },
          {
            "value": "bj_postszb",
            "label": "人民邮电报"
          },
          {
            "value": "bj_rmtdbszb",
            "label": "人民铁道报"
          },
          {
            "value": "bj_jkbcor",
            "label": "健康报"
          },
          {
            "value": "bj_peodjkrgdb",
            "label": "健康时报"
          },
          {
            "value": "bj_kmszb",
            "label": "光明日报(数字报)"
          },
          {
            "value": "bj_gysbszb",
            "label": "公益时报"
          },
          {
            "value": "nmrb",
            "label": "农民日报"
          },
          {
            "value": "bjzb",
            "label": "北京周报"
          },
          {
            "value": "hxsbocr",
            "label": "华夏时报"
          },
          {
            "value": "bj_ckxxocr",
            "label": "参考消息"
          },
          {
            "value": "bj_gjsbszb",
            "label": "国际商报"
          },
          {
            "value": "bj_zydxxxbszb",
            "label": "学习时报"
          },
          {
            "value": "grrn",
            "label": "工人日报"
          },
          {
            "value": "xhmr",
            "label": "新华每日电讯"
          },
          {
            "value": "jcrb",
            "label": "检察日报"
          },
          {
            "value": "bj_lddzb",
            "label": "法治日报"
          },
          {
            "value": "bj_qgbszb",
            "label": "消费日报(数字报)"
          },
          {
            "value": "bj_peodhq",
            "label": "环球时报"
          },
          {
            "value": "bj_kjdszb",
            "label": "科技日报(数字报)"
          },
          {
            "value": "bj_kpsbszb",
            "label": "科普时报"
          },
          {
            "value": "bj_jjckbszb",
            "label": "经济参考报(数字报)"
          },
          {
            "value": "bj_econ",
            "label": "经济日报"
          },
          {
            "value": "jfjb",
            "label": "解放军报"
          },
          {
            "value": "zqrb",
            "label": "证券日报"
          },
          {
            "value": "sz_zjsb",
            "label": "证券时报"
          },
          {
            "value": "bj_jrsb",
            "label": "金融时报"
          },
          {
            "value": "bj_qnckszb",
            "label": "青年参考"
          }
        ]
      },
      {
        "value": "cat2-t2",
        "label": "新闻通讯社",
        "children": [
          {
            "value": "bj_chinanews",
            "label": "中国新闻社"
          }
        ]
      },
      {
        "value": "cat2-t3",
        "label": "杂志",
        "children": [
          {
            "value": "slsh",
            "label": "三联生活周刊"
          },
          {
            "value": "zgbdd",
            "label": "中国报道"
          },
          {
            "value": "xwzk",
            "label": "中国新闻周刊"
          },
          {
            "value": "jjzk",
            "label": "中国经济周刊"
          },
          {
            "value": "bj_rmltdzb",
            "label": "人民论坛"
          },
          {
            "value": "bqzk",
            "label": "北京青年周刊"
          },
          {
            "value": "bj_chinacommontmr",
            "label": "半月谈"
          },
          {
            "value": "nfrwzk",
            "label": "南方人物周刊"
          },
          {
            "value": "gd_newweeklymr",
            "label": "新周刊"
          },
          {
            "value": "xmzk",
            "label": "新民周刊"
          },
          {
            "value": "bj_xwzxmr",
            "label": "新闻战线"
          },
          {
            "value": "minshengweekly",
            "label": "民生周刊"
          },
          {
            "value": "bj_fzyxwmr",
            "label": "法制与新闻"
          },
          {
            "value": "fzzm",
            "label": "法治周末"
          },
          {
            "value": "hqzz",
            "label": "环球"
          },
          {
            "value": "hqrw",
            "label": "环球人物"
          },
          {
            "value": "lwxwzk",
            "label": "瞭望"
          },
          {
            "value": "lwdf",
            "label": "瞭望东方周刊"
          }
        ]
      },
      {
        "value": "cat2-t4",
        "label": "网站",
        "children": [
          {
            "value": "wm_cntvstockcn",
            "label": "CCTV证券资讯"
          },
          {
            "value": "wm_cgtncn",
            "label": "CGTN"
          },
          {
            "value": "wm_egseacn",
            "label": "e公司"
          },
          {
            "value": "wm_globaltimescn",
            "label": "GLOBALTIMES"
          },
          {
            "value": "wm_lifeweekcn",
            "label": "三联生活周刊"
          },
          {
            "value": "wm_cnstockcn",
            "label": "上海证券报.中国证券网"
          },
          {
            "value": "wm_eastobaccocn",
            "label": "东方烟草网"
          },
          {
            "value": "wm_cnpeoplecn",
            "label": "中华儿女新闻网"
          },
          {
            "value": "wm_zhhzcn",
            "label": "中华合作时报"
          },
          {
            "value": "wm_cbtcn",
            "label": "中华工商网"
          },
          {
            "value": "wm_cntcmcn",
            "label": "中国中医药网"
          },
          {
            "value": "wm_zgjtbcn",
            "label": "中国交通新闻网"
          },
          {
            "value": "wm_ciniccn",
            "label": "中国产业经济信息网"
          },
          {
            "value": "wm_hsmcn",
            "label": "中国侨网"
          },
          {
            "value": "wm_zgxxbcn",
            "label": "中国信息报"
          },
          {
            "value": "wm_gqtorgcn",
            "label": "中国共青团网"
          },
          {
            "value": "wm_chinamilcn",
            "label": "中国军网"
          },
          {
            "value": "wm_js7tvcn",
            "label": "中国军视网"
          },
          {
            "value": "wm_nyxwcn",
            "label": "中国农业新闻网"
          },
          {
            "value": "wm_crnewscn",
            "label": "中国农村网"
          },
          {
            "value": "wm_farmercn",
            "label": "中国农网"
          },
          {
            "value": "wm_chinadevelopmentcn",
            "label": "中国发展网"
          },
          {
            "value": "wm_chinataiwancn",
            "label": "中国台湾网"
          },
          {
            "value": "wm_shangbaocn",
            "label": "中国商务新闻网"
          },
          {
            "value": "wm_zgswcncn",
            "label": "中国商网"
          },
          {
            "value": "wm_zgcsbcn",
            "label": "中国城市网"
          },
          {
            "value": "wm_chnfundcn",
            "label": "中国基金报"
          },
          {
            "value": "wm_cnwomencn",
            "label": "中国妇女网"
          },
          {
            "value": "wm_aqsccn",
            "label": "中国安全生产网"
          },
          {
            "value": "wm_zgsjbscn",
            "label": "中国审计报"
          },
          {
            "value": "wm_cmrnncn",
            "label": "中国市场监管信息网"
          },
          {
            "value": "wm_chinajsbcn",
            "label": "中国建设新闻网"
          },
          {
            "value": "wm_chinareportsorgcn",
            "label": "中国报道"
          },
          {
            "value": "wm_tripchinasocn",
            "label": "中国搜索"
          },
          {
            "value": "wm_chinareformcn",
            "label": "中国改革网"
          },
          {
            "value": "wm_jybcn",
            "label": "中国教育新闻网"
          },
          {
            "value": "wm_centvcn",
            "label": "中国教育网络电视台"
          },
          {
            "value": "wm_ccdycn",
            "label": "中国文化传媒网"
          },
          {
            "value": "wm_wenmingcn",
            "label": "中国文明网"
          },
          {
            "value": "wm_inewsweekcn",
            "label": "中国新闻周刊网"
          },
          {
            "value": "wm_caischinacn",
            "label": "中国新闻报道"
          },
          {
            "value": "wm_chinanewscn",
            "label": "中国新闻网"
          },
          {
            "value": "wm_wctnewscn",
            "label": "中国旅游新闻网"
          },
          {
            "value": "wm_chinadailycn",
            "label": "中国日报中文网"
          },
          {
            "value": "wm_epaperchinadailycn",
            "label": "中国日报网"
          },
          {
            "value": "wm_chinadailycomcn",
            "label": "中国日报网－国际"
          },
          {
            "value": "wm_cnmncn",
            "label": "中国有色网"
          },
          {
            "value": "wm_greentimescn",
            "label": "中国林业新闻网"
          },
          {
            "value": "wm_zgdazxwcn",
            "label": "中国档案资讯网"
          },
          {
            "value": "wm_mzbcn",
            "label": "中国民族宗教网"
          },
          {
            "value": "wm_cnrmzcn",
            "label": "中国民族广播网"
          },
          {
            "value": "wm_caacnewscn",
            "label": "中国民航网"
          },
          {
            "value": "wm_cmagovcn",
            "label": "中国气象局"
          },
          {
            "value": "wm_zgqxbcn",
            "label": "中国气象新闻网"
          },
          {
            "value": "wm_chinawatercn",
            "label": "中国水利"
          },
          {
            "value": "wm_cnautonewscn",
            "label": "中国汽车报网"
          },
          {
            "value": "wm_chinacourtcn",
            "label": "中国法院网"
          },
          {
            "value": "wm_cenewscn",
            "label": "中国环境"
          },
          {
            "value": "wm_zdxwcn",
            "label": "中国电力新闻网"
          },
          {
            "value": "wm_iprchncn",
            "label": "中国知识产权资讯网"
          },
          {
            "value": "wm_sinopecnewscn",
            "label": "中国石化新闻网"
          },
          {
            "value": "wm_newscnpccn",
            "label": "中国石油新闻中心"
          },
          {
            "value": "wm_cascn",
            "label": "中国科学院"
          },
          {
            "value": "wm_kepugovcn",
            "label": "中国科普网"
          },
          {
            "value": "wm_ctaxorgcn",
            "label": "中国税务网"
          },
          {
            "value": "wm_ceisxinhua08cn",
            "label": "中国经济信息社"
          },
          {
            "value": "wm_cehcn",
            "label": "中国经济导报网"
          },
          {
            "value": "wm_cecn",
            "label": "中国经济网"
          },
          {
            "value": "wm_cbcn",
            "label": "中国经营网"
          },
          {
            "value": "wm_chinacomcn",
            "label": "中国网"
          },
          {
            "value": "wm_chinaorgcn",
            "label": "中国网-英文版"
          },
          {
            "value": "wm_tibetinforcn",
            "label": "中国西藏网"
          },
          {
            "value": "wm_cpdcn",
            "label": "中国警察网"
          },
          {
            "value": "wm_zgjx_xinhuanetcn",
            "label": "中国记协网"
          },
          {
            "value": "wm_cfencn",
            "label": "中国财经报网"
          },
          {
            "value": "wm_financialnewscn",
            "label": "中国金融新闻网"
          },
          {
            "value": "wm_chinapeacegovcn",
            "label": "中国长安网"
          },
          {
            "value": "wm_youthcn",
            "label": "中国青年网"
          },
          {
            "value": "wm_cnpharmcn",
            "label": "中国食品药品网"
          },
          {
            "value": "wm_goldcn",
            "label": "中国黄金网"
          },
          {
            "value": "wm_zhonghongwangcn",
            "label": "中宏网"
          },
          {
            "value": "wm_workercncn",
            "label": "中工网"
          },
          {
            "value": "wm_jwviewcn",
            "label": "中新经纬"
          },
          {
            "value": "wm_cscn",
            "label": "中证网"
          },
          {
            "value": "wm_cyolcn",
            "label": "中青在线"
          },
          {
            "value": "wm_peoplechinacn",
            "label": "人民中国"
          },
          {
            "value": "wm_pppodcn",
            "label": "人民健康"
          },
          {
            "value": "wm_rmzxbcn",
            "label": "人民政协网"
          },
          {
            "value": "wm_rmsznetcn",
            "label": "人民数字联播网"
          },
          {
            "value": "wm_hubpdgzscn",
            "label": "人民日报中央厨房"
          },
          {
            "value": "wm_haiwainetcn",
            "label": "人民日报海外版官网"
          },
          {
            "value": "wm_coopeoplecn",
            "label": "人民智作"
          },
          {
            "value": "wm_rmhbcn",
            "label": "人民画报"
          },
          {
            "value": "wm_peopledailycn",
            "label": "人民网"
          },
          {
            "value": "wm_rmltcn",
            "label": "人民论坛网"
          },
          {
            "value": "wm_peoplerailcn",
            "label": "人民铁道网"
          },
          {
            "value": "wm_rmxiongancn",
            "label": "人民雄安网"
          },
          {
            "value": "wm_jkbcn",
            "label": "健康报网"
          },
          {
            "value": "wm_jksbcn",
            "label": "健康时报网"
          },
          {
            "value": "wm_gmwcn",
            "label": "光明网"
          },
          {
            "value": "wm_hubpdcn",
            "label": "全国党媒信息公共平台"
          },
          {
            "value": "wm_gongyishibaocn",
            "label": "公益时报"
          },
          {
            "value": "wm_ifengweeklycn",
            "label": "凤凰周刊"
          },
          {
            "value": "wm_qzsstcncn",
            "label": "券中社"
          },
          {
            "value": "wm_beijingreviewcn",
            "label": "北京周报网"
          },
          {
            "value": "wm_banyuetancn",
            "label": "半月谈网"
          },
          {
            "value": "wm_chinatimescn",
            "label": "华夏时报网"
          },
          {
            "value": "wm_huaxiacn",
            "label": "华夏经纬网"
          },
          {
            "value": "wm_cankaoxiaoxicn",
            "label": "参考消息网"
          },
          {
            "value": "wm_cricn",
            "label": "国际在线"
          },
          {
            "value": "wm_ifnewscn",
            "label": "国际金融报网"
          },
          {
            "value": "wm_cnrcn",
            "label": "央广网"
          },
          {
            "value": "wm_cctvcomcn",
            "label": "央视网"
          },
          {
            "value": "wm_cntvcn_315",
            "label": "央视网315晚会"
          },
          {
            "value": "wm_xuexicn",
            "label": "学习强国"
          },
          {
            "value": "wm_culcncn",
            "label": "文化中国"
          },
          {
            "value": "wm_mrdxxinhuanetcn",
            "label": "新华每日电讯"
          },
          {
            "value": "wm_xinhuanetcn",
            "label": "新华网"
          },
          {
            "value": "wm_big5newscn",
            "label": "新华网-繁体版"
          },
          {
            "value": "wm_chinaviewcn",
            "label": "新华网-英文版"
          },
          {
            "value": "wm_xinminweeklycn",
            "label": "新民周刊"
          },
          {
            "value": "wm_xwzxbjbcn",
            "label": "新闻战线网"
          },
          {
            "value": "wm_qizhiwangcn",
            "label": "旗帜网"
          },
          {
            "value": "wm_k618cn",
            "label": "未来网"
          },
          {
            "value": "wm_jcrbcn",
            "label": "正义网"
          },
          {
            "value": "wm_msweeklycn",
            "label": "民生网"
          },
          {
            "value": "wm_qstheorycn",
            "label": "求是"
          },
          {
            "value": "wm_fzwcn",
            "label": "法制网"
          },
          {
            "value": "wm_legalweeklycn",
            "label": "法治周末"
          },
          {
            "value": "wm_legaldailycn",
            "label": "法治网"
          },
          {
            "value": "wm_xfrbcn",
            "label": "消费日报网"
          },
          {
            "value": "wm_globalpeoplecn",
            "label": "环球人物网"
          },
          {
            "value": "wm_huanqiucn",
            "label": "环球网"
          },
          {
            "value": "wm_cntheorycn",
            "label": "理论网"
          },
          {
            "value": "wm_cenacn",
            "label": "电子信息产业网"
          },
          {
            "value": "wm_lwxinhuanetcn",
            "label": "瞭望周刊社"
          },
          {
            "value": "wm_lwdx1cn",
            "label": "瞭望网"
          },
          {
            "value": "wm_sciencenetcn",
            "label": "科学网"
          },
          {
            "value": "wm_zggorgcn",
            "label": "紫光阁"
          },
          {
            "value": "wm_jjckbcn",
            "label": "经济参考网"
          },
          {
            "value": "wm_jingjiribaocn",
            "label": "经济日报"
          },
          {
            "value": "wm_greenchinanetcn",
            "label": "绿色中国网"
          },
          {
            "value": "wm_artchinacn",
            "label": "艺术中国"
          },
          {
            "value": "wm_ccstockcn",
            "label": "证券日报网"
          },
          {
            "value": "wm_secutimescn",
            "label": "证券时报网.中国"
          },
          {
            "value": "wm_cailianpresscn",
            "label": "财联社"
          },
          {
            "value": "wm_ccidnetcn",
            "label": "赛迪网"
          },
          {
            "value": "wm_ccidcomcn",
            "label": "通信产业网"
          },
          {
            "value": "wm_yujianwangcn",
            "label": "遇见中国"
          }
        ]
      },
      {
        "value": "cat2-t5",
        "label": "视频",
        "children": [
          {
            "value": "wm_tv_cctv13cn",
            "label": "CCTV-13新闻"
          },
          {
            "value": "wm_tv_cetvcn",
            "label": "中国教育网络电视网"
          },
          {
            "value": "wm_tv_tvpeoplecn",
            "label": "人民视频-人民网"
          },
          {
            "value": "wm_tv_vcctvcn",
            "label": "央视网视频"
          }
        ]
      },
      {
        "value": "cat2-t6",
        "label": "论坛",
        "children": [
          {
            "value": "forum_peoplecn",
            "label": "强国论坛(人民网)"
          }
        ]
      }
    ]
  },
  {
    "value": "cat3",
    "label": "垂类重要媒体",
    "children": [
      {
        "value": "cat3-t0",
        "label": "APP",
        "children": [
          {
            "value": "wm_emaocn_app",
            "label": "一猫汽车网"
          },
          {
            "value": "wm_esczjcn_app",
            "label": "二手车之家"
          },
          {
            "value": "wm_kczjcn_app",
            "label": "卡车之家"
          },
          {
            "value": "wm_dzzccn_app",
            "label": "大众侃车"
          },
          {
            "value": "wm_pcauto_app",
            "label": "太平洋汽车网"
          },
          {
            "value": "wm_dongchedicn_app",
            "label": "懂车帝"
          },
          {
            "value": "wm_autosohu_app",
            "label": "搜狐汽车"
          },
          {
            "value": "wm_xincheping_app",
            "label": "新车评"
          },
          {
            "value": "wm_bitauto_app",
            "label": "易车"
          },
          {
            "value": "wm_ycyhcn_app",
            "label": "有车以后"
          },
          {
            "value": "wm_autohome_app",
            "label": "汽车之家"
          },
          {
            "value": "wm_qichedaquancn_app",
            "label": "汽车大全"
          },
          {
            "value": "wm_qctt_app",
            "label": "汽车头条"
          },
          {
            "value": "wm_qcbjdqcn_app",
            "label": "汽车报价大全"
          },
          {
            "value": "wm_akqccn_app",
            "label": "爱卡汽车"
          },
          {
            "value": "wm_gsqccn_app",
            "label": "盖世汽车"
          },
          {
            "value": "wm_dycwcn_app",
            "label": "第一车网"
          },
          {
            "value": "wm_cheshi_app",
            "label": "网上车市"
          },
          {
            "value": "wm_czzjcn_app",
            "label": "车主之家"
          },
          {
            "value": "wm_cyttcn_app",
            "label": "车友头条"
          },
          {
            "value": "wm_chezhiwangcn_app",
            "label": "车质网"
          },
          {
            "value": "wm_cheluncn_app",
            "label": "车轮"
          }
        ]
      },
      {
        "value": "cat3-t1",
        "label": "报纸",
        "children": [
          {
            "value": "sh_shqcszb",
            "label": "上海汽车报"
          },
          {
            "value": "hb_dfqchbszb",
            "label": "东风汽车报"
          },
          {
            "value": "bjqc",
            "label": "北京汽车报"
          },
          {
            "value": "qcsbsub",
            "label": "汽车商报"
          },
          {
            "value": "mdve",
            "label": "汽车生活报"
          },
          {
            "value": "cheyoumr",
            "label": "车友报"
          }
        ]
      },
      {
        "value": "cat3-t2",
        "label": "杂志",
        "children": [
          {
            "value": "zyqc",
            "label": "专用汽车"
          },
          {
            "value": "sjqc",
            "label": "世界汽车"
          },
          {
            "value": "zqhbsub",
            "label": "中国汽车画报"
          },
          {
            "value": "mczhsub",
            "label": "名车志"
          },
          {
            "value": "syqc",
            "label": "商用汽车"
          },
          {
            "value": "syqcn",
            "label": "商用汽车新闻"
          },
          {
            "value": "gjqcsjjzc",
            "label": "国际汽车设计及制造"
          },
          {
            "value": "iaotozz",
            "label": "市场周刊·汽车公社"
          },
          {
            "value": "autosotysub",
            "label": "汽车与社会"
          },
          {
            "value": "qcypj",
            "label": "汽车与配件"
          },
          {
            "value": "qczysub",
            "label": "汽车之友"
          },
          {
            "value": "bitautowk",
            "label": "汽车周刊"
          },
          {
            "value": "bj_autobrsub",
            "label": "汽车商业评论"
          },
          {
            "value": "qchzsub",
            "label": "汽车族"
          },
          {
            "value": "shautobild",
            "label": "汽车画刊"
          },
          {
            "value": "czzysub",
            "label": "车主之友"
          },
          {
            "value": "chemsub",
            "label": "车迷"
          },
          {
            "value": "jcqbsub",
            "label": "轿车情报"
          }
        ]
      },
      {
        "value": "cat3-t3",
        "label": "网站",
        "children": [
          {
            "value": "wm_315qccn",
            "label": "315汽车网"
          },
          {
            "value": "wm_42howcn",
            "label": "42号车库"
          },
          {
            "value": "wm_xgocn",
            "label": "58汽车"
          },
          {
            "value": "wm_acqichecn",
            "label": "AC汽车"
          },
          {
            "value": "wm_yihaocarcn",
            "label": "一号汽车"
          },
          {
            "value": "wm_emaocn",
            "label": "一猫汽车网"
          },
          {
            "value": "wm_zhongyuanautocn",
            "label": "中原汽车网"
          },
          {
            "value": "wm_chinatruckcn",
            "label": "中国卡车网"
          },
          {
            "value": "wm_35carcn",
            "label": "中国商用汽车网"
          },
          {
            "value": "wm_chinabusescn",
            "label": "中国客车网"
          },
          {
            "value": "wm_autoinfocn",
            "label": "中国汽车工业信息网"
          },
          {
            "value": "wm_315checn_315",
            "label": "中国汽车消费网315汽车投诉"
          },
          {
            "value": "wm_cncarucn",
            "label": "中国汽车联盟"
          },
          {
            "value": "wm_aqsiqautocn",
            "label": "中国汽车质量网"
          },
          {
            "value": "wm_ddcnetcn",
            "label": "中国电动车网"
          },
          {
            "value": "wm_autonetcn",
            "label": "中车网"
          },
          {
            "value": "wm_che168cn",
            "label": "二手车之家"
          },
          {
            "value": "wm_yescarcn",
            "label": "亚讯车网"
          },
          {
            "value": "wm_zhongchecn",
            "label": "众车网"
          },
          {
            "value": "wm_qqddccn",
            "label": "全球电动车网"
          },
          {
            "value": "wm_ecv360cn",
            "label": "卡车之友"
          },
          {
            "value": "wm_360checn",
            "label": "卡车之家"
          },
          {
            "value": "wm_kacherencn",
            "label": "卡车人"
          },
          {
            "value": "wm_360truckscn",
            "label": "卡车信息网"
          },
          {
            "value": "wm_cvchomecn",
            "label": "商用车之家"
          },
          {
            "value": "wm_newscvcn",
            "label": "商用车新网"
          },
          {
            "value": "wm_cv2000cn",
            "label": "商用车界"
          },
          {
            "value": "wm_chinacarscn",
            "label": "商用车网"
          },
          {
            "value": "wm_truck998cn",
            "label": "商用车联盟"
          },
          {
            "value": "wm_56851cn",
            "label": "商车天下"
          },
          {
            "value": "wm_cn357cn",
            "label": "商车网"
          },
          {
            "value": "wm_cvzonecn",
            "label": "商车邦"
          },
          {
            "value": "wm_dazhongkanchecn",
            "label": "大众侃车"
          },
          {
            "value": "wm_dahecccn",
            "label": "大河车城网"
          },
          {
            "value": "wm_tfautocn",
            "label": "天府汽车网"
          },
          {
            "value": "wm_pcautojxs_vtc",
            "label": "太平洋汽车网"
          },
          {
            "value": "wm_360busescn",
            "label": "客车信息网"
          },
          {
            "value": "wm_qqylqcn",
            "label": "尊流汽车网"
          },
          {
            "value": "wm_cdqcwcn",
            "label": "常德汽车网"
          },
          {
            "value": "wm_gxqcwcn",
            "label": "广西汽车网"
          },
          {
            "value": "wm_dcdappcn",
            "label": "懂车帝"
          },
          {
            "value": "wm_cntpluscn",
            "label": "提加商用车"
          },
          {
            "value": "wm_autosohucn",
            "label": "搜狐汽车"
          },
          {
            "value": "wm_autosinacn",
            "label": "新浪汽车"
          },
          {
            "value": "wm_xaautosinacn",
            "label": "新浪汽车西安站"
          },
          {
            "value": "wm_xinchepingcn",
            "label": "新车评网"
          },
          {
            "value": "wm_cnautotimeccn",
            "label": "时代汽车网"
          },
          {
            "value": "wm_bitautocn",
            "label": "易车网"
          },
          {
            "value": "wm_selecarcn",
            "label": "智选车"
          },
          {
            "value": "wm_yourchecn",
            "label": "有车智联"
          },
          {
            "value": "wm_yocarscn",
            "label": "有车网"
          },
          {
            "value": "wm_teccrrcziccn",
            "label": "株洲中车时代电气股份有限公司"
          },
          {
            "value": "wm_iautodailycn",
            "label": "每日汽车"
          },
          {
            "value": "wm_dripcarcn",
            "label": "水滴汽车"
          },
          {
            "value": "wm_qichezhuanyecn",
            "label": "汽车专业网"
          },
          {
            "value": "wm_autofancn",
            "label": "汽车之友"
          },
          {
            "value": "wm_autohomecn",
            "label": "汽车之家"
          },
          {
            "value": "wm_autoreportcn",
            "label": "汽车产经网"
          },
          {
            "value": "wm_chekbcn",
            "label": "汽车口碑网"
          },
          {
            "value": "wm_autoweeklycn",
            "label": "汽车商业网"
          },
          {
            "value": "wm_inabrcn",
            "label": "汽车商业评论"
          },
          {
            "value": "wm_bcarcn",
            "label": "汽车商务网"
          },
          {
            "value": "wm_qichedaquancn",
            "label": "汽车大全"
          },
          {
            "value": "wm_autosightcn",
            "label": "汽车大观"
          },
          {
            "value": "wm_qcttcn",
            "label": "汽车头条"
          },
          {
            "value": "wm_automarketcn",
            "label": "汽车市场网"
          },
          {
            "value": "wm_autotimescn",
            "label": "汽车时代网"
          },
          {
            "value": "wm_315checn",
            "label": "汽车消费网"
          },
          {
            "value": "wm_autoreviewcn",
            "label": "汽车纵横网"
          },
          {
            "value": "wm_qichejingweicn",
            "label": "汽车经纬"
          },
          {
            "value": "wm_qcwpcn",
            "label": "汽车网评"
          },
          {
            "value": "wm_autobizcn",
            "label": "汽车财经"
          },
          {
            "value": "wm_qcxlwcn",
            "label": "汽车销量网"
          },
          {
            "value": "wm_qichemencn",
            "label": "汽车门"
          },
          {
            "value": "wm_autofieldcn",
            "label": "汽车领域"
          },
          {
            "value": "wm_autohenancn",
            "label": "河南汽车在线"
          },
          {
            "value": "wm_hncwcn",
            "label": "河南车网"
          },
          {
            "value": "wm_zjqcwcn",
            "label": "浙江汽车网"
          },
          {
            "value": "wm_zjchewangcn",
            "label": "浙江车网"
          },
          {
            "value": "wm_rdcvwcn",
            "label": "润鼎商用车"
          },
          {
            "value": "wm_c168ccncn",
            "label": "深圳车城网"
          },
          {
            "value": "wm_autoxxcn",
            "label": "潇湘汽车网"
          },
          {
            "value": "wm_yzqcwcn",
            "label": "燕赵汽车网"
          },
          {
            "value": "wm_autohebcn",
            "label": "燕赵车网"
          },
          {
            "value": "wm_xcarcn",
            "label": "爱卡汽车网"
          },
          {
            "value": "wm_niuchecn",
            "label": "牛车网"
          },
          {
            "value": "wm_wanchezhijiacn",
            "label": "玩车之家"
          },
          {
            "value": "wm_eotruckcn",
            "label": "环球卡车网"
          },
          {
            "value": "wm_huanqiuautocn",
            "label": "环球汽车网"
          },
          {
            "value": "wm_zhevcn",
            "label": "电车之家"
          },
          {
            "value": "wm_evpartnercn",
            "label": "电车资源"
          },
          {
            "value": "wm_engasgoocn",
            "label": "盖世汽车"
          },
          {
            "value": "wm_gasgoocn",
            "label": "盖世汽车网"
          },
          {
            "value": "wm_movecarcn",
            "label": "移动汽车网"
          },
          {
            "value": "wm_diyichecn",
            "label": "第1汽车网"
          },
          {
            "value": "wm_cvworldcn",
            "label": "第一商用车网"
          },
          {
            "value": "wm_newevcarcn",
            "label": "第一新车网"
          },
          {
            "value": "wm_diyievcn",
            "label": "第一电动汽车"
          },
          {
            "value": "wm_iautoscn",
            "label": "第一车网"
          },
          {
            "value": "wm_cheshicn",
            "label": "网上车市"
          },
          {
            "value": "wm_auto163cn",
            "label": "网易汽车"
          },
          {
            "value": "wm_news18acn",
            "label": "网通社.汽车"
          },
          {
            "value": "wm_lianzhongautocn",
            "label": "联众汽车"
          },
          {
            "value": "wm_szcwcn",
            "label": "苏州车网"
          },
          {
            "value": "wm_shucarcn",
            "label": "蜀车网"
          },
          {
            "value": "wm_029carcn",
            "label": "西安汽车网"
          },
          {
            "value": "wm_gzqccn",
            "label": "贵州汽车网"
          },
          {
            "value": "wm_lookartvcn",
            "label": "路咖汽车"
          },
          {
            "value": "wm_16888cn",
            "label": "车主之家"
          },
          {
            "value": "wm_chezhubiducn",
            "label": "车主必读"
          },
          {
            "value": "wm_icautocn",
            "label": "车主指南"
          },
          {
            "value": "wm_chezhilvcn",
            "label": "车之旅"
          },
          {
            "value": "wm_cheyuncn",
            "label": "车云网"
          },
          {
            "value": "wm_cyb800cn",
            "label": "车友邦"
          },
          {
            "value": "wm_chetxiacn",
            "label": "车天下汽车"
          },
          {
            "value": "wm_0755carcn",
            "label": "车神榜"
          },
          {
            "value": "wm_chextxcn",
            "label": "车行天下"
          },
          {
            "value": "wm_chexuncn",
            "label": "车讯网"
          },
          {
            "value": "wm_12365autocn",
            "label": "车质网"
          },
          {
            "value": "wm_chewencn",
            "label": "车问网"
          },
          {
            "value": "wm_dizhuchecn",
            "label": "迪族车网"
          },
          {
            "value": "wm_chooseautocn",
            "label": "选车网"
          },
          {
            "value": "wm_talkcvcn",
            "label": "韬克商用车"
          }
        ]
      },
      {
        "value": "cat3-t4",
        "label": "论坛",
        "children": [
          {
            "value": "forum_pcautocn",
            "label": "太平洋汽车网论坛"
          },
          {
            "value": "forum_bitautocn",
            "label": "易车网论坛"
          },
          {
            "value": "forum_autohomecn",
            "label": "汽车之家论坛"
          },
          {
            "value": "forum_12365autocn",
            "label": "车质网"
          }
        ]
      }
    ]
  },
  {
    "value": "cat4",
    "label": "市场监管",
    "children": [
      {
        "value": "cat4-t0",
        "label": "网站",
        "children": [
          {
            "value": "wm_saicgovcn",
            "label": "国家市场监督管理总局"
          },
          {
            "value": "wm_ccaicn",
            "label": "国家市场监督管理总局认证认可技术研究中心"
          }
        ]
      }
    ]
  },
  {
    "value": "cat5",
    "label": "投诉类",
    "children": [
      {
        "value": "cat5-t0",
        "label": "网站",
        "children": [
          {
            "value": "wm_china-consumercn",
            "label": "中国消费者网"
          },
          {
            "value": "wm_cqncn",
            "label": "中国质量新闻网"
          },
          {
            "value": "wm_12315cncn",
            "label": "全国12315平台"
          },
          {
            "value": "wm_bj315orgcn",
            "label": "北京市消费者协会"
          },
          {
            "value": "wm_qichetousucn",
            "label": "汽车质量投诉网"
          },
          {
            "value": "wm_xfb315cn",
            "label": "消费保"
          },
          {
            "value": "wm_sinacn_315",
            "label": "黑猫投诉"
          }
        ]
      }
    ]
  }
]

export const CHANNEL_CASCADER_PROPS = {
  multiple: true,
  emitPath: true,
  checkStrictly: false,
  expandTrigger: 'hover'
}

/** value -> label */
export function buildChannelValueLabelMap(options = CHANNEL_OPTIONS, map = {}) {
  options.forEach(node => {
    if (node.children && node.children.length) {
      buildChannelValueLabelMap(node.children, map)
    } else if (node.value) {
      map[node.value] = node.label
    }
  })
  return map
}

/** 将 cascader 多选路径转为平台 label 列表（去重） */
export function flattenChannelPaths(paths, valueLabelMap) {
  const map = valueLabelMap || buildChannelValueLabelMap()
  const labels = []
  ;(paths || []).forEach(path => {
    if (!path || !path.length) return
    const leaf = path[path.length - 1]
    const label = map[leaf]
    if (label && !labels.includes(label)) {
      labels.push(label)
    }
  })
  return labels
}

/** 选项树二级节点是媒体形态；TOP媒体 分类下二级节点是平台品牌名，不属于形态 */
const FORM_MEDIA_TYPES = ['网站', 'APP', '报纸', '杂志', '论坛', '视频', '新闻通讯社']

/** 形态在 name 后缀里的写法，mediaType 字段仍保留字典原值 */
const MEDIA_TYPE_NAME_SUFFIX = { APP: 'App' }

function trimText(value) {
  return String(value == null ? '' : value).trim()
}

/**
 * 从选项树摊平出叶子元数据。
 * 树的层级与渠道字典一一对应：[mediaCategory, mediaType, mediaName]，叶子 value 即 pubCode。
 */
function buildLeafIndex(options) {
  const leaves = []
  ;(function walk(nodes, labels, values) {
    nodes.forEach(node => {
      const nextLabels = labels.concat(node.label)
      const nextValues = values.concat(node.value)
      if (node.children && node.children.length) {
        walk(node.children, nextLabels, nextValues)
        return
      }
      leaves.push({
        category: nextLabels[0] || '',
        mediaType: nextLabels.length >= 3 ? nextLabels[1] || '' : '',
        media: node.label,
        pubCode: node.value,
        path: nextValues
      })
    })
  })(options, [], [])

  const mediaCount = {}
  leaves.forEach(leaf => {
    mediaCount[leaf.media] = (mediaCount[leaf.media] || 0) + 1
  })
  leaves.forEach(leaf => {
    const isFormType = FORM_MEDIA_TYPES.indexOf(leaf.mediaType) >= 0
    // 同一媒体常有「网站」「APP」两条，媒体名重复时才补形态后缀区分
    const needSuffix = isFormType && mediaCount[leaf.media] > 1
    leaf.name = needSuffix ? leaf.media + (MEDIA_TYPE_NAME_SUFFIX[leaf.mediaType] || leaf.mediaType) : leaf.media
    leaf.storedMediaType = isFormType ? leaf.mediaType : ''
  })
  return leaves
}

const LEAF_LIST = buildLeafIndex(CHANNEL_OPTIONS)
const LEAF_BY_PUB_CODE = {}
const LEAF_BY_NAME = {}
const LEAF_BY_MEDIA = {}
LEAF_LIST.forEach(leaf => {
  LEAF_BY_PUB_CODE[leaf.pubCode] = leaf
  if (!LEAF_BY_NAME[leaf.name]) LEAF_BY_NAME[leaf.name] = leaf
  if (!LEAF_BY_MEDIA[leaf.media]) LEAF_BY_MEDIA[leaf.media] = leaf
})

/** 落库结构：{ name, media, mediaType?, pubCode }，品牌型渠道不带 mediaType */
function leafToStorageEntry(leaf) {
  const entry = { name: leaf.name, media: leaf.media }
  if (leaf.storedMediaType) {
    entry.mediaType = leaf.storedMediaType
  }
  entry.pubCode = leaf.pubCode
  return entry
}

/** 将 cascader 多选路径转为落库结构，按 pubCode 去重 */
export function channelPathsToEntries(paths) {
  const entries = []
  const seen = {}
  ;(paths || []).forEach(path => {
    if (!path || !path.length) return
    const leaf = LEAF_BY_PUB_CODE[path[path.length - 1]]
    if (!leaf || seen[leaf.pubCode]) return
    seen[leaf.pubCode] = true
    entries.push(leafToStorageEntry(leaf))
  })
  return entries
}

function legacyChannelLabel(value) {
  const legacy = { weibo: '微博', wechat: '微信', news: '新闻', forum: '论坛' }
  const text = trimText(value)
  if (!text) return ''
  return legacy[text.toLowerCase()] || text
}

/** 字典里已下架的渠道仍需能展示，兜底成一个无路径的游离条目 */
function detachedLeaf(fields) {
  return {
    category: fields.category || '',
    mediaType: fields.mediaType || '',
    media: fields.media,
    pubCode: fields.pubCode || '',
    name: fields.name || fields.media,
    storedMediaType: fields.mediaType || '',
    path: null
  }
}

/**
 * 把单个存量元素解析回叶子。pubCode 唯一且稳定，优先用它匹配；
 * 其次按 name，最后退回媒体名（同名时用 mediaType / category 消歧）。
 */
function resolveLeaf(item) {
  if (item && typeof item === 'object') {
    const pubCode = trimText(item.pubCode || item.code)
    if (pubCode && LEAF_BY_PUB_CODE[pubCode]) return LEAF_BY_PUB_CODE[pubCode]
    const name = trimText(item.name)
    if (name && LEAF_BY_NAME[name]) return LEAF_BY_NAME[name]
    const media = trimText(item.media || item.mediaName)
    if (!media) return null
    const mediaType = trimText(item.mediaType)
    const category = trimText(item.category || item.mediaCategory)
    const matched = LEAF_LIST.filter(leaf => leaf.media === media)
    if (matched.length) {
      const byType = mediaType ? matched.filter(leaf => leaf.mediaType === mediaType)[0] : null
      const byCategory = category ? matched.filter(leaf => leaf.category === category)[0] : null
      return byType || byCategory || matched[0]
    }
    return detachedLeaf({ category: category, mediaType: mediaType, media: media, pubCode: pubCode, name: name })
  }
  const label = legacyChannelLabel(item)
  if (!label) return null
  return LEAF_BY_NAME[label] || LEAF_BY_MEDIA[label] || detachedLeaf({ media: label })
}

/**
 * 解析 channel 字段为叶子列表。兼容四种历史形态：
 * 当前的 { name, media, mediaType, pubCode }、上一版的 { category, media }、
 * 更早的媒体名数组，以及最早的单值编码（weibo 等）。
 */
export function parseChannelEntries(channelJson) {
  if (!channelJson) return []
  let parsed = null
  try {
    parsed = JSON.parse(channelJson)
  } catch (error) {
    parsed = null
  }
  const list = Array.isArray(parsed)
    ? parsed
    : [typeof parsed === 'string' && parsed ? parsed : channelJson]
  const entries = []
  const seen = {}
  list.forEach(item => {
    const leaf = resolveLeaf(item)
    if (!leaf) return
    const key = leaf.pubCode || leaf.name
    if (seen[key]) return
    seen[key] = true
    entries.push(leaf)
  })
  return entries
}

/** 解析 channel 字段为落库结构，用于把存量数据升级成当前格式 */
export function channelJsonToEntries(channelJson) {
  return parseChannelEntries(channelJson).map(leafToStorageEntry)
}

/** 解析后端 channel JSON 为展示文本 */
export function formatChannelLabels(channelJson) {
  const entries = parseChannelEntries(channelJson)
  if (!entries.length) return '—'
  return entries.map(entry => entry.name).join('、')
}

/** 根据 label 列表反查 cascader 路径（同名取首个匹配） */
export function labelsToChannelPaths(labels, options = CHANNEL_OPTIONS) {
  const paths = []
  ;(labels || []).forEach(label => {
    const path = findPathByLabel(options, label, [])
    if (path) paths.push(path)
  })
  return paths
}

function findPathByLabel(nodes, label, prefix) {
  for (let i = 0; i < nodes.length; i += 1) {
    const node = nodes[i]
    const current = prefix.concat(node.value)
    if (!node.children || !node.children.length) {
      if (node.label === label) return current
    } else {
      const found = findPathByLabel(node.children, label, current)
      if (found) return found
    }
  }
  return null
}

/** 还原 cascader 路径；已下架的渠道无对应路径，直接跳过 */
export function entriesToChannelPaths(entries) {
  const paths = []
  const seen = {}
  ;(entries || []).forEach(entry => {
    const leaf = entry && entry.path ? entry : resolveLeaf(entry)
    if (!leaf || !leaf.path || seen[leaf.pubCode]) return
    seen[leaf.pubCode] = true
    paths.push(leaf.path.slice())
  })
  return paths
}

/** 解析 channel 字段为媒体名数组（兼容旧格式） */
export function parseChannelLabels(channelJson) {
  return parseChannelEntries(channelJson).map(entry => entry.media)
}
